export const ADD = "ADD";
export const ADD_CHILD = "ADD_CHILD";
export const REMOVE = "REMOVE";
export const GetCaseBYId = "GetCaseBYId";
export const REPLACE = "REPLACE";
export const CLEAR_FORM_STATE = "CLEAR_FORM_STATE";
export const CASE_NOT_FOUND = "CASE_NOT_FOUND";
export const RESET_CASE_NOT_FOUND = "RESET_CASE_NOT_FOUND";
